"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UniversalSigner = void 0;
const utils_1 = require("ethers/lib/utils");
class UniversalSigner {
    static getDigestForData(data) {
        const message = JSON.stringify(data);
        const digest = (0, utils_1.keccak256)((0, utils_1.toUtf8Bytes)(message));
        return digest;
    }
    static signStringifiableData(data, privateKey) {
        const digest = UniversalSigner.getDigestForData(data);
        const signingKey = new utils_1.SigningKey(privateKey);
        const fullSignature = signingKey.signDigest(digest);
        return (0, utils_1.joinSignature)(fullSignature);
    }
    static recoverSigner(data, signature) {
        const digest = UniversalSigner.getDigestForData(data);
        const publicKey = (0, utils_1.recoverPublicKey)(digest, signature);
        return (0, utils_1.computeAddress)(publicKey);
    }
    static signWithEthereumHashMessage(signerOrWallet, message) {
        return signerOrWallet.signMessage(message);
    }
    static recoverAddressFromEthereumHashMessage(message, signature) {
        return (0, utils_1.verifyMessage)(message, signature);
    }
}
exports.UniversalSigner = UniversalSigner;
//# sourceMappingURL=UniversalSigner.js.map